import React, { useState, useRef, useEffect } from "react";
import Modal from "../../components/Modal/Modal";
import ApiManager from "../../ApiManager/ApiManager";
import { LoadingSpinner } from "../../components/LoadingSpinner/LoadingSpinner";
import "./FuelCard.css";

const statusColors = {
  approved: "approved",
  rejected: "rejected",
  pending: "pending",
  created: "created",
  default: ""
};

const FuelCard = ({ fuel }) => {
  const [expanded, setExpanded] = useState(false);
  const [showFile, setShowFile] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [loadingFile, setLoadingFile] = useState(false);
  const status = (fuel.status || "default").toLowerCase();

  // For smooth animation
  const bodyRef = useRef(null);
  const [bodyHeight, setBodyHeight] = useState(0);

  useEffect(() => {
    if (expanded && bodyRef.current) {
      setBodyHeight(bodyRef.current.scrollHeight);
    } else {
      setBodyHeight(0);
    }
  }, [expanded]);

  const handleReceiptClick = async (e) => {
    e.stopPropagation();
    if (!fuel.file_path_fuel) return;
    setShowFile(true);
    setLoadingFile(true);
    setFileUrl(null);
    setFileType(null);
    try {
      const query = new URLSearchParams({ file_name: fuel.file_path_fuel });
      const response = await ApiManager.getFile(query);
      if (!response.ok) throw new Error("Failed to fetch file");
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const mimeType = response.headers.get("Content-Type");
      setFileUrl(url);
      setFileType(mimeType);
    } catch (error) {
      setFileUrl(null);
      setFileType(null);
    }
    setLoadingFile(false);
  };

  return (
    <div className={`fuel-card${expanded ? " expanded" : ""}`}>
      {/* Accordion Header */}
      <div
        className={`fuel-card-header${expanded ? " expanded" : ""}`}
        onClick={() => setExpanded((e) => !e)}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <span className="fuel-card-type">
            {fuel.fuel_type || "Type"}
          </span>
          <span className="fuel-card-date">
            {fuel.created_at
              ? new Date(fuel.created_at).toLocaleString('en-GB', {
                  day: '2-digit',
                  month: '2-digit', 
                  year: 'numeric',
                  hour: 'numeric',
                  minute: '2-digit',
                  hour12: true,
                  timeZone: 'Asia/Kolkata'
                }).replace(',', '')
              : "No Date"}
          </span>
          <span className="fuel-card-amount">
            ₹{fuel.amount}
          </span>
          <span className={`fuel-card-status ${statusColors[status]}`}>
            {fuel.status ? fuel.status.charAt(0).toUpperCase() + fuel.status.slice(1) : "Unknown"}
          </span>
        </div>
        <span className="fuel-card-arrow">{expanded ? "⌃" : "⌄"}</span>
      </div>
      {/* Accordion Body with smooth transition */}
      <div
        className="fuel-card-body"
        style={{
          maxHeight: expanded ? bodyHeight : 0,
          opacity: expanded ? 1 : 0
        }}
      >
        <div ref={bodyRef} className="fuel-card-body-inner">
          <div style={{ marginBottom: 8 }}>
            <b>Fuel Quantity:</b> {fuel.fuel_amount} L
          </div>
          <div style={{ marginBottom: 8 }}>
            <b>Description:</b> {fuel.description}
          </div>
          <div style={{ marginBottom: 8 }}>
            <b>Km Reading:</b> {fuel.km_reading}
          </div>
          {fuel.file_path_fuel && (
            <button
              className="custom-button"
              onClick={handleReceiptClick}
            >
              View Receipt
            </button>
          )}
          {showFile && (
            <Modal isOpen={showFile} onClose={() => setShowFile(false)} title="Fuel Receipt">
              {loadingFile ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
                  <LoadingSpinner message="Loading file..." />
                </div>
              ) : fileUrl ? (
                fileType === "application/pdf" ? (
                  <iframe src={fileUrl} width="100%" height="500px" title="Fuel Receipt PDF"></iframe>
                ) : (
                  <img
                    src={fileUrl}
                    alt="Fuel Receipt"
                    style={{ maxWidth: "100%", objectFit: "contain", display: "block", margin: "auto" }}
                  />
                )
              ) : (
                <p>Loading file...</p>
              )}
            </Modal>
          )}
        </div>
      </div>
    </div>
  );
};

export default FuelCard; 